import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { LayoutGrid } from 'lucide-react'
import { isFlagEffectivelyEnabled } from '../../constants/featureFlags'
import { useAppMode } from '../../contexts/AppModeContext'
import { useAppSuiteSettings } from '../../contexts/AppSuiteSettingsContext'
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext'
import { useBranding } from '../../contexts/UiCustomizationContext'

export function AppExperienceMenu({ close }: { close: () => void }) {
  const { t } = useTranslation()
  const { isApps, enterApps, enterClassic } = useAppMode()
  const { suite } = useAppSuiteSettings()
  const { flags } = useFeatureFlags()
  const { platform_only: platformOnly } = useBranding()
  const flagOn = isFlagEffectivelyEnabled('app_suites_view', flags)
  const appsAvailable =
    flagOn &&
    !platformOnly &&
    !suite?.platform_only &&
    Boolean(suite?.apps.some((app) => app.enabled))
  const canSwitch = Boolean(suite?.allow_experience_switch) && appsAvailable

  const onClassic = useCallback(() => {
    close()
    enterClassic()
  }, [close, enterClassic])
  const onTryApps = useCallback(() => {
    close()
    enterApps()
  }, [close, enterApps])

  return (
    <>
      {isApps && canSwitch && (
        <button type="button" className="user-menu-item" role="menuitem" onClick={onClassic}>
          <LayoutGrid size={14} />
          <span>{t('appSuites.userMenu.classic')}</span>
        </button>
      )}
      {!isApps && canSwitch && (
        <button type="button" className="user-menu-item" role="menuitem" onClick={onTryApps}>
          <LayoutGrid size={14} />
          <span>{t('appSuites.userMenu.tryApps')}</span>
        </button>
      )}
    </>
  )
}
